import { render, staticRenderFns } from "./BeforeLogoutDialog.vue?vue&type=template&id=65d9c3f0&scoped=true&"
import script from "./BeforeLogoutDialog.vue?vue&type=script&lang=js&"
export * from "./BeforeLogoutDialog.vue?vue&type=script&lang=js&"
import style0 from "./BeforeLogoutDialog.vue?vue&type=style&index=0&id=65d9c3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9c3f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
